// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format17 } from '../../constants';

/** Germany */
const DE: PhoneNumberData = [49, 'DE', 11, format17];

export default DE;
